@if (case) {
    <mat-card
        class="case-card"
        (click)="openCaseDialog()"
        (keyup.enter)="$event.preventDefault(); openCaseDialog()"
        (keyup.space)="$event.preventDefault(); openCaseDialog()"
        [attr.aria-label]="case.title"
        [attr.data-testid]="caseTestId + index()"
        [attr.data-case-createdby]="case.reportedbyId"
        [attr.data-case-status]="case.statuscode"
        [attr.data-case-businessarea]="case.businessareaId"
        [attr.data-case-createdon]="case.createdon"
        [attr.data-case-title]="case.title"
        tabindex="0"
        appearance="outlined"
    >
        <mat-card-content>
            <div class="case-card__top">
                <mat-card-title [attr.data-testid]="'case-title-' + index()">{{ case.title }}</mat-card-title>
                <div class="case-card__top__right">
                    @if (case.dueDate) {
                        <div class="due-date">
                            <mat-icon class="material-symbols-outlined due-date-icon" aria-hidden="true" style="color: #466817"> watch_later </mat-icon>
                            <span class="due-date-date">
                                {{ case.dueDate | date: "dd-MM-yyyy kl. HH:mm" }}
                            </span>
                        </div>
                    }
                    @if (case.createdon) {
                        <div class="date-frame">
                            <span class="text-default date">
                                {{ case.createdon | date: "dd-MM-yyyy" }}
                            </span>
                        </div>
                    }
                    <span class="text-default case-card__top__status" [style]="'background-color: ' + getStatusColor(case.statuscode) + ';'">
                        {{ getStatusCodeValue(case.statuscode) }}
                    </span>
                </div>
            </div>
            <div class="case-card__content">
                <div class="text-default">
                    @if (case.description) {
                        <p>
                            {{ case.description }}
                        </p>
                    }
                </div>
            </div>
        </mat-card-content>
    </mat-card>
}
